export const SAME_ADDRESS_ERROR_MSG = 'Alamat pengirim dan penerima tidak boleh sama';

export function normalizeAddress(value) {
  return String(value || '').trim().toLowerCase().replace(/\s+/g, '');
}

export function isSameSenderRecipientAddress(senderAddress, recipientAddress) {
  const a = normalizeAddress(senderAddress);
  const b = normalizeAddress(recipientAddress);
  if (!a || !b) return false;
  return a === b;
}
